import React from 'react'
import { Stack } from '@mui/material';
import { LineWave } from 'react-loader-spinner';

const Loader = () => {
  return (
    <Stack direction="row" justifyContent="center" alignItems="center" width="100%">
        <LineWave
          color="#b30086"
          height={310}
          width={110}
          ariaLabel="three-circles-rotating"
        />
    </Stack>
  )
}

export default Loader